import { Trainee } from "../trainee/trainee";

export class SessionTest {
    date: string;
    participants: number;
    totalParticipants: number;

    constructor(date: string, participants: number, totalParticipants: number) {
        this.date = date;
        this.participants = participants;
        this.totalParticipants = totalParticipants;
    }
}

export class OfferSession {
    sessionKey?: number;
    offerKey: number;
    dateLib: string;
    sessionStartDate: Date;
    sessionEndDate: Date;
    quantity: number;
    isActive?: boolean;
    bookedSessionTrainees?: number;

    constructor(offerKey: number, dateLib: string, sessionStartDate: Date, sessionEndDate: Date, quantity: number) {
        this.offerKey = offerKey;
        this.dateLib = dateLib;
        this.sessionStartDate = sessionStartDate;
        this.sessionEndDate = sessionEndDate;
        this.quantity = quantity;
    }
}

export class Session {
  dateLib: string;
  sessionStartDate: Date;
  sessionEndDate: Date;

  constructor(dateLib: string, sessionStartDate: Date, sessionEndDate: Date) {
      this.dateLib = dateLib;
      this.sessionStartDate = sessionStartDate;
      this.sessionEndDate = sessionEndDate;
  }
}

export class SessionByDate {
  sessionKey?: number;
  offerKey: number;
  dateLib: string;
  sessionStartDate: Date | string;
  sessionEndDate: Date | string;
  quantity: number;
  bookedSessionTrainees?: number;
  offerName: string;
  status: string;
  rating?: number;
  ratingTotal?: number;

  constructor(offerKey: number, dateLib: string, sessionStartDate: Date | string, sessionEndDate: Date | string, quantity: number) {
      this.offerKey = offerKey;
      this.dateLib = dateLib;
      this.sessionStartDate = sessionStartDate;
      this.sessionEndDate = sessionEndDate;
      this.quantity = quantity;
  }
}

export class SessionForRating {
  dateLib: string;
  sessionStartDate: Date | string;
  sessionEndDate: Date | string;
  offerName: string;
  trainees: Trainee[];
  picture: string;
  logo: string;
  clubName: string;
}

export class SessionStatus {
  bookedSessionStatusKey: number;
  name: string

  constructor(bookedSessionStatusKey: number, name: string) {
    this.bookedSessionStatusKey = bookedSessionStatusKey;
    this.name = name;
  }
}
